<template>
    <AdminPanelYoutvService />
   </template>
   
   <script>
   import AdminPanelYoutvService from '../components/AdminPanelYoutvService.vue'
   export default {
       data: () => ({}),
       components: {
           AdminPanelYoutvService
       },
       methods: {},
       mounted() {}
   }
   </script>
   